import { render } from "./responses.vue?vue&type=template&id=e4b27d88"
import script from "./responses.vue?vue&type=script&lang=js"
export * from "./responses.vue?vue&type=script&lang=js"
script.render = render

export default script